export default "__VITE_ASSET__72567817__"